module.exports = __webpack_public_path__ + "static/image-4-b41859204c85dd1503862d577716e464.webp";